import { styled } from '@mui/material';

export const Form = styled('form')(({ noMargin, theme }) => ({
  width: '100%',
  marginTop: !noMargin ? theme.spacing(3) : 0,
}));
